/** @format */

import React from 'react'
import { _$ } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import AlarmTactics from 'src/containers/MonitorAlarmTemplate'

const MonitorAlarmTactics: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('告警服务') }, { title: _$('触发条件模版') }]} />
      <AlarmTactics />
    </div>
  )
}

export default styled(MonitorAlarmTactics)`
  padding: 0 16px;
`
